export interface SalesAgentsCommissionDetails {
  agent: string;
  agentName: string;
  orderNo: string;
  crmNo: string;
  dateInvoiced: Date;
  documentType: string;
  invoiceNo: number;
  orderTypeDescription: string;
  sellingCompany: string;
  customerAccount: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  productType: string;
  productKey: string;
  oldCode: string;
  productDescription: string;
  customerLineRef: string;
  noOfItems: number;
  quantity: number;
  uom: string;
  priceListQty: number;
  cuom: string;
  despatchQty: number;
  price: number;
  discount: number;
  currencyCode: string;
  currencyValue: number;
  rate: number;
  sterlingValue: number;
  commissionRate: number;
  commissionValue: number;
  commissionIsAmount: string;
}
